module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-41.340f4e84.png";